
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';
import { LocalStorageService, ObjetsService } from '../../shared';

@Component({
  selector: 'app-form-b',
  templateUrl: './app-form-b.component.html',
  providers: [ObjetsService]
})
export class AppFormBComponent implements OnInit {
  public formName = 'rubrique_B_situation_bien';
  public metaData: any = [];
  public datasInsee: any = [];
  public datasSection: any = [];
  public supTotal = 0;
  public hiddenItems: any = [];
  public showItems: any = [];
  public new = false;

  public validRefCad: Array<boolean> = [];
  private lineIndex = 0;
  private alive = true;
  private mutating = false;

  /**
   * Liste des communes. Alimentée de l'extérieur par form-dia (loadListeCommune).
   * Le setter re-synchronise les selects localité après que les options sont rendues.
   */
  private _datas: any = [];
  get datas() { return this._datas; }
  set datas(value: any) {
    this._datas = value;
    if (value && value.length > 0) {
      // Après que Angular a rendu les options, forcer la re-synchronisation
      // des selects localité dont la valeur a été patchée avant l'arrivée des données
      setTimeout(() => {
        const rcControls = this.refCadData.controls;
        for (let i = 0; i < rcControls.length; i++) {
          const currentValue = rcControls[i].get('refcad_localite').value;
          if (currentValue && currentValue !== '' && currentValue !== 'null') {
            rcControls[i].get('refcad_localite').setValue(currentValue, { emitEvent: false });
          }
        }
      });
    }
  }
  loading: any = [];
  loadingSection: any = [];

  /**
   * Émis lorsque la liste des parcelles change (ajout, suppression)
   */
  @Output() parcelsChanged = new EventEmitter<void>();

  situationBien: FormGroup;
  refCad: FormGroup;
  divisionParcellaire: FormGroup;
  itemsDp: FormArray;
  itemsSb: FormArray;
  itemsRc: FormArray;

  constructor(
    private readonly _objetsService: ObjetsService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly formBuilder: FormBuilder,
    private readonly toastr: ToastsManager,
    private readonly localStorageService: LocalStorageService) {}

  get situationBienData() { return <FormArray>this.situationBien.get('itemsSb'); }
  get refCadData() { return <FormArray>this.refCad.get('itemsRc'); }
  get divisionParcellaireData() { return <FormArray>this.divisionParcellaire.get('itemsDp'); }

  ngOnInit (): void {

    this.loading[0] = false;
    this.loadingSection[0] = false;
    this.divisionParcellaire = new FormGroup({
      b_plan_cad_joint: new FormControl(),
    });

    this.situationBien = new FormGroup({
      b_adresse__superficie: new FormControl({disabled: true}),
    });

    this.refCad = new FormGroup({
      refcad_prefixe: new FormControl(null),
      refcad_section: new FormControl('', Validators.required),
      refcad_numero: new FormControl('', Validators.required),
      refcad_lieu_dit: new FormGroup({
        rivoli: new FormControl(),
        lib: new FormControl()
      }, Validators.required),
      refcad_superficie: new FormControl(),
      refcad_localite: new FormControl('', Validators.required),
    });

    this.situationBien = this.formBuilder.group({
      itemsSb: this.formBuilder.array([ this.createItem('sb') ])
    });

    this.resetParcelles();

    this.divisionParcellaire = this.formBuilder.group({
      itemsDp: this.formBuilder.array([ this.createItem('dp') ])
    });

    this.restoreParcelsFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    // Le flag mutating empêche la sauvegarde pendant les modifications structurelles
    // du FormArray (removeAt / push) où l'état interne (lineIndex, showItems) est incohérent
    this.refCad.valueChanges.subscribe(() => {
      if (!this.mutating) { this.saveParcelsToStorage(); }
    });
    this.divisionParcellaire.valueChanges.subscribe(() => this.saveParcelsToStorage());
  }

  ngAfterViewChecked(){
    this.changeDetector.detectChanges();
  }

  /**
   * RAZ de la liste des parcelles
   */
  resetParcelles(): void {
    this.supTotal = 0;
    this.metaData = [];
    this.datasInsee = [];
    this.datasSection = [];
    this.hiddenItems = [];
    this.showItems = [];
    this.new = false;
    this.validRefCad = [];
    this.lineIndex = 0;
    this.showItems[0] = true;

    this.refCad = this.formBuilder.group({
      itemsRc: this.formBuilder.array([ this.createItem('rc') ])
    });
  }

  /**
   * Créée un nouvel élément programmatiquement (sans vérification préalable)
   *
   * @param i index (démarre à 0)
   * @param sup superficie à ajouter au total
   * @returns le groupe correspondant
   */
  addNewItem(i, sup): FormGroup {
    this.mutating = true;
    this.lineIndex = this.lineIndex + 1;
    this.showItems[this.lineIndex] = true;

    this.itemsRc = this.refCad.get('itemsRc') as FormArray;
    const formGroup = this.createItem('rc');
    this.itemsRc.push(formGroup);

    this.hiddenItems[i] = true;
    this.showItems[i] = false;

    this.supTotal = this.supTotal + sup;

    this.situationBien.get('itemsSb').get('0').get('b_adresse__superficie').setValue(this.supTotal);
    this.mutating = false;
    return formGroup;
  }

  private getControlListTextValue(control) {
    if(control.value === 'null') {
      return '';
    } else {
      return control.value;
    }
  }

  isSuperficieInvalide(item: FormGroup) {
    const surface = Number(item.controls.refcad_superficie.value);
    return !Number.isFinite(surface) || surface <= 0;
  }

  /**
   * Vérifier si la ligne courante est OK pour l'enregistrement
   */
  public checkLineValidity(currentIndex: number): boolean {
    const line = this.refCad.get('itemsRc').get(currentIndex.toString());

    // Le formulaire pouvait etre validé avec un number vide...
    let valid = line.valid
      && Number.isFinite(line.get('refcad_numero').value)
      && Number.isFinite(line.get('refcad_superficie').value)
      && line.get('refcad_superficie').value > 0
      && this.listNotVoid(currentIndex, 'refcad_lieu_dit')
      && this.listNotVoid(currentIndex, 'refcad_section')
      && this.listNotVoid(currentIndex, 'refcad_localite');

    if(valid) {
      for(let lowerIndex = currentIndex - 1 ; lowerIndex >= 0 ; lowerIndex--) {
        // Vérifier si la parcelle n'a pas déjà été saisie
        if(
          this.refCad.get('itemsRc').get(lowerIndex.toString()).get('refcad_numero').value === line.get('refcad_numero').value &&
          this.refCad.get('itemsRc').get(lowerIndex.toString()).get('refcad_lieu_dit').value.rivoli === line.get('refcad_lieu_dit').value.rivoli &&
          this.refCad.get('itemsRc').get(lowerIndex.toString()).get('refcad_section').value === line.get('refcad_section').value &&
          this.refCad.get('itemsRc').get(lowerIndex.toString()).get('refcad_localite').value === line.get('refcad_localite').value
        ) {
          valid = false;
          this.toastr.error('Cette parcelle existe déjà.', 'Doublon');
        }
      }
    }

    return valid;
  }

  /**
   * Ajoute une parcelle
   *
   * @param i index (démarre à 0)
   * @param sup superficie à ajouter au total
   */
  addItem(currentIndex ,sup): void {
    const valid = this.checkLineValidity(currentIndex);
    this.validRefCad[currentIndex] = valid;

    if (valid) {
      this.addNewItem(currentIndex, sup);
      this.saveParcelsToStorage();
      this.parcelsChanged.emit();
    }
  }

  private listNotVoid(index: number, fieldName: string) {
    const line = this.refCad.get('itemsRc').get(index.toString());
    return line.get(fieldName).value !== ''
      && line.get(fieldName).value !== 'null';
  }

  /**
   * Fonction gérant l'affichage des messages de non validités des champs ainsi que la classe associée à cette dernière
   *
   * @param dirty
   * @param typePerson
   * @param {string} type
   * @returns {any}
   */
  checkFieldValidity(dirty, i, type = 'validity'): any {
    const valid = this.validRefCad[i];

    switch (type) {
      case 'class':
        if (valid === false && !dirty) {
          return 'is-invalid';
        } else {
          return '';
        }
      default:
        if (valid === false && !dirty) {
          return true;
        } else {
          return false;
        }
    }
  }

  /**
   * Préselection des select boxes de 'section' associées à cet index pour une parcelle existante
   * @param index indice en cours
   */
  private preloadSectionSelectBox(index: number) {
    const sectionValue = this.refCad.get('itemsRc').get(index.toString()).get('refcad_section').value;

    let sectionIndex = 0;
    if (sectionValue != null) {
      for (const section of this.datasSection[index]) {
        sectionIndex++;
        if (section === sectionValue) {
          break;
        }
      }
    }

    const element = (document.getElementById(`refcad_section_${index}`) as HTMLSelectElement);
    if(element != null) {
      element.selectedIndex = sectionIndex;
    }
  }

  /**
   * Préselection des select boxes de 'lieu dit' associées à cet index pour une parcelle existante
   * @param index indice en cours
   */
  private preloadLieuDitSelectBox(index: number) {
    const lieuDitValue = this.refCad.get('itemsRc').get(index.toString()).get('refcad_lieu_dit').value;

    let lieuDitIndex = 0;
    if (lieuDitValue != null) {
      for (const lieuDit of this.datasInsee[index]) {
        lieuDitIndex++;
        if (lieuDit.rivoli === lieuDitValue.rivoli) {
          break;
        }
      }
    }

    const element = (document.getElementById(`refcad_lieu_dit_${index}`) as HTMLSelectElement);
    if(element != null) {
      element.selectedIndex = lieuDitIndex;
    }
  }

  /**
   * Préselection des select boxes associées à cet index pour une parcelle existante
   * @param index indice en cours
   */
  private preloadLocationSelectBox(index: number) {
    const locationValue = this.refCad.get('itemsRc').get(index.toString()).get('refcad_localite').value;

    let locationIndex = 0;
    if (locationValue != null) {
      for (const location of this.datas) {
        locationIndex++;
        if (location.communeCodeInsee === locationValue) {
          break;
        }
      }
    }

    // Forcer la selection de la profession
    (document.getElementById(`refcad_localite_${index}`) as HTMLSelectElement).selectedIndex = locationIndex;
  }

  /**
   * Affiche le formulaire d'une parcelle
   *
   * @param i
   */
  showItem(i): void {
    if (this.hiddenItems[i]) {
      const newTotal = this.supTotal - this.refCad.get('itemsRc').get(i.toString()).get('refcad_superficie').value;
      this.supTotal = newTotal > 0 ? newTotal : 0;
      this.preloadLocationSelectBox(i);
      this.preloadLieuDitSelectBox(i);
      this.preloadSectionSelectBox(i);
      this.hiddenItems[i] = false;
    } else {
      this.supTotal = this.supTotal + this.refCad.get('itemsRc').get(i.toString()).get('refcad_superficie').value;
      this.hiddenItems[i] = true;
      this.saveParcelsToStorage();
      this.parcelsChanged.emit();
    }
  }

  /**
   * Supprime une parcelle
   *
   * @param i
   */
  deleteItem(i , sup): void {
    const newTotal = this.supTotal + this.refCad.get('itemsRc').get(i.toString()).get('refcad_superficie').value - sup;
    this.supTotal = newTotal > 0 ? newTotal : 0;

    this.situationBien.get('itemsSb').get('0').get('b_adresse__superficie').setValue(this.supTotal);

    this.mutating = true;
    this.hiddenItems.splice(i, 1);
    this.showItems.splice(i, 1);
    this.validRefCad.splice(i, 1);
    this.itemsRc.removeAt(i);
    this.lineIndex = this.lineIndex - 1;
    this.showItems[this.lineIndex] = true;
    this.mutating = false;
    this.saveParcelsToStorage();
    this.parcelsChanged.emit();
  }

  /**
   * Si la checkbox nouvelle étude est cochée cette fonction réinitialise les champs de l'étude
   */
  setSectionFieldsNew(): void {
    this.new = !this.new;
  }

  /**
   * Appel le webservice récupérant la liste des lieux dit en fonction du code INSEE de la commune
   *
   * @param insee
   * @param idPars
   */
  loadListeLieuDit(insee, idPars, restoreValue?: any): void {
    this._objetsService.listeLieuDit(insee).takeWhile(() => this.alive).subscribe(
      result => {
        this.datasInsee[idPars] = result;
        this.loading[idPars] = false;
        // Après que les options sont rendues, forcer la re-synchronisation du select
        if (restoreValue !== undefined) {
          setTimeout(() => {
            this.refCadData.at(idPars).get('refcad_lieu_dit').setValue(restoreValue, { emitEvent: false });
          });
        }
      },
      error => { this.metaData = <any>error }
    );
  }

  /**
   * Classe à appliquer au select 'localité'
   * @param index indice de la parcelle
   * @returns l'ensemble des classes de base
   */
  getLocaliteClass(index: number): string {
    return `${this.checkFieldValidity((this.refCadData.controls[index] as FormGroup)
      .controls.refcad_localite.dirty, index, 'class')} form-control`;
  }

  /**
   * Classe à appliquer au select 'section'
   * @param index indice de la parcelle
   * @returns l'ensemble des classes de base
   */
  getSectionClass(index: number): string {
    return `${this.checkFieldValidity((this.refCadData.controls[index] as FormGroup)
    .controls.refcad_section.dirty, index, 'class')} form-control`;
  }

  /**
   * Classe à appliquer au select 'section'
   * @param index indice de la parcelle
   * @returns l'ensemble des classes de base
   */
  getLieuDitClass(index: number): string {
    return `${this.checkFieldValidity((this.refCadData.controls[index] as FormGroup)
    .controls.refcad_lieu_dit.dirty, index, 'class')} form-control`;
  }

  /**
   * Appel le webservice récupérant la liste des lieux dit en fonction du code INSEE de la commune
   *
   * @param insee
   * @param idPars
   */
  loadlisteSectionByInsee(insee, idPars, restoreValue?: any): void {
    this._objetsService.listeSectionByInsee(insee).takeWhile(() => this.alive).subscribe(
      result => {
        this.datasSection[idPars] = result;
        this.loadingSection[idPars] = false;
        // Après que les options sont rendues, forcer la re-synchronisation du select
        if (restoreValue !== undefined) {
          setTimeout(() => {
            this.refCadData.at(idPars).get('refcad_section').setValue(restoreValue, { emitEvent: false });
          });
        }
      },
      error => { this.metaData = <any>error }
    );
  }

  /**
   * Fournis le code INSEE à la fonction loadListeLieuDit
   *
   * @param insee
   * @param idPars
   */
  communeSelection(insee, idPars, restoreSection?: any, restoreLieuDit?: any): void {
    // Remplir automatiquement le nom de la localité depuis la liste des communes
    if (this._datas && this._datas.length > 0) {
      const commune = this._datas.find(d => d.communeCodeInsee === insee);
      if (commune) {
        this.refCadData.at(idPars).get('refcad_localite_nom').setValue(commune.communeLib, { emitEvent: false });
      }
    }
    this.loading[idPars] = true;
    this.loadingSection[idPars] = true;
    this.datasInsee[idPars] = null;
    this.datasSection[idPars] = null;
    this.loadlisteSectionByInsee(insee, idPars, restoreSection);
    this.loadListeLieuDit(insee, idPars, restoreLieuDit);
  }


  /**
   * Créé un formGroup pour le formarray
   *
   * @param type
   * @returns {FormGroup}
   */
  createItem(type): FormGroup {
    if (type === 'sb')  {
      return this.formBuilder.group({
        b_adresse__superficie: '',
      });
    } else if (type === 'rc') {
      return this.formBuilder.group({
        refcad_prefixe: null,
        refcad_section: '',
        refcad_numero: null,
        refcad_lieu_dit: '',
        refcad_superficie: null,
        refcad_localite: '',
        refcad_localite_nom: ''
      });
    } else if (type === 'dp') {
      return this.formBuilder.group({
        b_plan_cad_joint: false,
      });
    }
  }

  /**
   * Comparateur pour la select box lieu-dit :
   * compare par rivoli pour éviter les problèmes de référence après désérialisation JSON.
   */
  compareLieuDit(a: any, b: any): boolean {
    if (!a || !b) { return a === b; }
    return a.rivoli === b.rivoli;
  }

  /**
   * Sauvegarde les parcelles enregistrées, le brouillon en cours et la division parcellaire
   * dans le localStorage. Exclut la dernière entrée vide (formulaire d'ajout).
   */
  private saveParcelsToStorage(): void {
    const rcControls = this.refCadData.controls;
    const parcels = [];
    for (let i = 0; i < rcControls.length - 1; i++) {
      parcels.push(rcControls[i].value);
    }

    // Le formulaire d'ajout en cours est la dernière entrée
    const currentForm = this.showItems[this.lineIndex]
      ? this.refCadData.at(this.lineIndex).value
      : null;

    this.localStorageService.save('form_b', {
      parcels,
      supTotal: this.supTotal,
      divisionParcellaire: this.divisionParcellaireData.at(0).value,
      currentForm,
      newSection: this.new
    });
  }

  /**
   * Restaure les parcelles, la division parcellaire et le brouillon depuis le localStorage.
   * Reconstruit les FormArrays, les tableaux d'affichage et relance les appels commune
   * pour chaque parcelle enregistrée.
   */
  private restoreParcelsFromStorage(): void {
    const saved = this.localStorageService.load('form_b');
    if (!saved) { return; }

    const savedParcels: any[] = saved.parcels;
    if (savedParcels && savedParcels.length > 0) {
      this.resetParcelles();

      // Remplir la première entrée (déjà créée par resetParcelles)
      this.refCadData.at(0).patchValue(savedParcels[0], { emitEvent: false });
      this.hiddenItems[0] = true;
      this.showItems[0] = false;
      this.validRefCad[0] = true;

      // Relancer le chargement des sections et lieux-dits pour la première parcelle
      const firstLocalite = savedParcels[0].refcad_localite;
      if (firstLocalite && firstLocalite !== '' && firstLocalite !== 'null') {
        this.communeSelection(firstLocalite, 0, savedParcels[0].refcad_section, savedParcels[0].refcad_lieu_dit);
      }

      // Ajouter les parcelles suivantes
      for (let i = 1; i < savedParcels.length; i++) {
        const group = this.createItem('rc');
        this.refCadData.push(group);
        this.refCadData.at(i).patchValue(savedParcels[i], { emitEvent: false });
        this.hiddenItems[i] = true;
        this.showItems[i] = false;
        this.validRefCad[i] = true;

        const localite = savedParcels[i].refcad_localite;
        if (localite && localite !== '' && localite !== 'null') {
          this.communeSelection(localite, i, savedParcels[i].refcad_section, savedParcels[i].refcad_lieu_dit);
        }
      }

      // Ajouter l'entrée vide pour le prochain ajout
      const emptyRc = this.createItem('rc');
      this.refCadData.push(emptyRc);
      this.lineIndex = savedParcels.length;
      this.showItems[this.lineIndex] = true;
      this.itemsRc = this.refCadData;

      // Restaurer la superficie totale
      this.supTotal = saved.supTotal || 0;
      this.situationBien.get('itemsSb').get('0').get('b_adresse__superficie').setValue(this.supTotal);
    }

    // Restaurer le brouillon du formulaire en cours si présent
    if (saved.currentForm) {
      // D'abord patcher localité + numéro + superficie
      this.refCadData.at(this.lineIndex).patchValue(saved.currentForm, { emitEvent: false });

      // Charger les listes déroulantes section et lieu-dit via l'API
      const draftLocalite = saved.currentForm.refcad_localite;
      if (draftLocalite && draftLocalite !== '' && draftLocalite !== 'null') {
        this.communeSelection(draftLocalite, this.lineIndex, saved.currentForm.refcad_section, saved.currentForm.refcad_lieu_dit);
      }
    }

    // Restaurer la division parcellaire
    if (saved.divisionParcellaire != null) {
      this.divisionParcellaireData.at(0).patchValue(saved.divisionParcellaire, { emitEvent: false });
    }

    // Restaurer le flag "nouvelle section"
    if (saved.newSection) {
      this.new = true;
    }

    // Marquer les champs restaurés comme dirty pour éviter les faux positifs de validation
    for (let i = 0; i < this.refCadData.length; i++) {
      this.markFilledControlsDirty(this.refCadData.at(i));
    }
    this.markFilledControlsDirty(this.divisionParcellaireData.at(0));
  }

  /**
   * Marque comme dirty tous les contrôles du groupe ayant une valeur non vide.
   * Nécessaire après patchValue pour que checkFieldValidity n'affiche pas
   * d'erreur sur les champs restaurés depuis le localStorage.
   */
  private markFilledControlsDirty(group: any): void {
    if (!group || !group.controls) { return; }
    Object.keys(group.controls).forEach(key => {
      const val = group.controls[key].value;
      if (val !== null && val !== '' && val !== undefined) {
        group.controls[key].markAsDirty();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-b/app-form-b.component.ts